export default __webpack_public_path__ + "static/media/volunteer.9ff7b40c.png";